import { UserRole } from '../../store/types/context';

export { default as Component } from './DocumentGroup';
export const roles = [UserRole.Admin]
export const path = "/document-group";
